<template>
    <modal
        :title="translations.identificationCode || 'Identification code'"
        :cancel_btn_title="translations.cancel || 'Cancel'"
        size="small"
        name="partner_key_update"
    >
        <template #toggle>
            <options-item :title="translations.manage || 'Manage'"/>
        </template>
        <template #body>
            <div class="space-y-4">
                <text-field
                    :label="translations.identificationCode || 'Identification code'"
                    :model-value="key"
                    field-id="identification"
                    @update:modelValue="updateRefLink"
                    v-on:keyup.enter="update"
                    :error="error ? true : false"
                    :error-message="error"
                ></text-field>

                <div class="py-3 px-4 text-sm bg-gray-100 rounded">
                    <span class="opacity-60">{{ ref_link }}</span>
                </div>
            </div>
            <div class="text-lg font-medium truncate mt-9 mb-1.5">
                {{ translations.qrCode || 'QR code' }}
            </div>
            <qr-code
                :content="ref_link"
                :name="key"
                :button-type="button_type"
                :translations="{
                    qrCodeText: translations.qrCodeText,
                    download: translations.download,
                    embedCode: translations.embedCode,
                    embed: translations.embed,
                    print: translations.print,
                    copied: translations.copied,
                    copy: translations.copy,
                    cancel: translations.cancel,
                }"
            ></qr-code>
        </template>
        <template #footer>
            <btn :type="button_type" v-on:click="update" :loading="loading">
                {{ translations.update || 'Update' }}
            </btn>
        </template>
    </modal>
</template>
<script>
import OptionsItem from "../../elements/options/OptionsItem";
import QrCode from "../../elements/QrCode";

export default {
    props: ['ref_link_url', 'ref_link_key', 'update_url', 'button_type', 'translations'],
    data() {
        return {
            error: false,
            loading: false,
            key: this.ref_link_key,
            url: this.ref_link_url,
        }
    },
    methods: {
        update() {

            this.loading = true;

            const self = this;
            this.update_errors = [];

            axios
                .post(self.update_url, {key: self.key})
                .then(response => {
                    const status = parseInt(response.data.status || 0);
                    if (status === 1) {
                        this.emitter.emit('modal-off', 'partner_key_update');
                        window.location.reload();
                    } else {
                        this.error = 'Failed to update referral key';
                    }
                })
                .catch(error => {
                    let errors = error.response.data.errors.key || false;
                    self.error = Array.isArray(errors) ? errors[0] : errors;
                }).finally(() => this.loading = false);
        },
        updateRefLink(value) {
            this.key = value;
        }
    },
    computed: {
        ref_link() {
            return this.url + this.key;
        }
    },
    components: {
        OptionsItem,
        QrCode
    }
}
</script>
